import { ApolloClient, InMemoryCache} from '@apollo/client';
import fetch from 'isomorphic-fetch';

const client = new ApolloClient({
	uri: process.env.GATSBY_PATSTORE_GRAPHQL_API_URL,
	fetchOptions: {
		mode: 'no-cors'
	},
	headers: {
		'X-Parse-Application-Id': process.env.GATSBY_PATSTORE_APP_ID as string,
		'X-Parse-Master-Key': process.env.GATSBY_PATSTORE_MASTER_KEY as string
	},
	connectToDevTools: true,
	cache: new InMemoryCache(),
	fetch
});


export default client;
 